import { render, staticRenderFns } from "./FacturaResumen.vue?vue&type=template&id=0ee027a4&scoped=true&"
import script from "./FacturaResumen.vue?vue&type=script&lang=ts&"
export * from "./FacturaResumen.vue?vue&type=script&lang=ts&"
import style0 from "./FacturaResumen.vue?vue&type=style&index=0&id=0ee027a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee027a4",
  null
  
)

export default component.exports